import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';


export function validateCredentials(badgenumber) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',

        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_VALIDATECREDENTIALS);
    url += `?badgenumber=${badgenumber}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function authenticate(username, password) {
    const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: username,
            password: password,
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_AUTHENTICATEUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllMetisUsers() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLMETISUSERS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
};

export function getAllMetisUserRoles() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLMETISUSERROLES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllMetisUserFeatures() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLMETISUSERFEATURES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllEditableMetisUserFeatures() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLEDITABLEMETISUSERFEATURES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function createMetisUser(user) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEMETISUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function updateMetisUser(user) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEMETISUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllBagweigherUsers() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLBAGWEIGHERUSERS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
};

export function createBagweigherUser(user) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEBAGWEIGHERUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function updateBagweigherUser(user) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEBAGWEIGHERUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function CheckIfBadgeNumberIsFree(badgenumber, userId) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CHECKIFBADGENRISFREE);
    url += `?badgenumber=${badgenumber}`;
    url += `&userId=${userId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function DeleteMetisUser(userId) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEMETISUSER);
    url += `?userId=${userId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
